import { useEffect, useRef } from 'react';

/**
 * Componente que renderiza el footer + social del theme_templates JSON.
 * Usa innerHTML (no createContextualFragment) para garantizar que
 * los scripts embebidos NO se ejecuten.
 * @param {Function} onReady - Callback que se ejecuta cuando el HTML fue inyectado.
 */
export default function ThemeFooter({ footer, social, onReady }) {
  const markerRef = useRef(null);

  useEffect(() => {
    const marker = markerRef.current;
    if (!marker) return;

    const parent = marker.parentNode;
    const html = (footer || '') + (social || '');

    // Limpiar nodos previamente inyectados
    while (marker.nextSibling && marker.nextSibling.__themeFooter) {
      parent.removeChild(marker.nextSibling);
    }

    if (!html) return;

    // Parsear con DOMParser para tener control total (no ejecuta scripts)
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Remover todos los <script> del HTML parseado
    doc.querySelectorAll('script').forEach((s) => s.remove());

    // Insertar cada nodo después del marcador
    const nodes = Array.from(doc.body.childNodes);
    let insertPoint = marker;
    nodes.forEach((node) => {
      const imported = document.adoptNode(node);
      imported.__themeFooter = true;
      parent.insertBefore(imported, insertPoint.nextSibling);
      insertPoint = imported;
    });

    if (onReady) onReady();

    return () => {
      while (marker.nextSibling && marker.nextSibling.__themeFooter) {
        parent.removeChild(marker.nextSibling);
      }
    };
  }, [footer, social, onReady]);

  return <span ref={markerRef} style={{ display: 'none' }} />;
}
